import React, { useState, useEffect } from 'react';

const TextRotator = ({ texts, interval = 5000 }) => {
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
        }, interval);

        return () => clearInterval(timer);
    }, [texts.length, interval]);

    return (
        <>
            <h1 className="text-4xl mb-2 rotating-text">{texts[currentIndex].kanji}</h1>
            <div className="subtitle rotating-text">
                {texts[currentIndex].romaji} <span>({texts[currentIndex].meaning})</span>
            </div>
        </>
    );
};

export default TextRotator;
